<template>
	<app-page>
		<app-heading :title="isNew ? 'New Image' : image.filename" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;" class="mt-4 website-image-section">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button type="cancel" small :to="{ name: 'website-images' }">Cancel</app-button>
				</app-section-actions>
				<input-combobox
					label="Namespace"
					:items="namespaces"
					v-model="image.namespace"
					required
					:errors="errors.namespace"
				/>
				<input-text
					label="Filename"
					v-model="image.filename"
					required
					:errors="errors.filename"
				/>
				<input-file
					type="image"
					label="Image"
					image
					image-width="300"
					image-height="300"
					@load="onImport"
				/>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
export default {
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			if (this.id !== 'new') {
				const image = await this.$ravello.request()
					.v(2)
					.to('websites')
					.to(this.websiteId)
					.to('images')
					.to(this.id)
					.get()

				this.image.filename = image.filename
				this.image.namespace = image.namespace
			}
			this.namespaces = await this.$ravello.request()
				.v(2)
				.to('websites')
				.to(this.websiteId)
				.to('namespaces')
				.dataSource()
		} catch (err) {
			this.$notifications.pushAlert('error', err.data ? err.data.message : err.message)
		}
		this.$store.dispatch('app/stopLoading')
	},
	data() {
		return {
			namespaces: [],
			image: {
				filename: '',
				namespace: null,
				image: null,
			},
			errors: {},
		}
	},
	computed: {
		websiteId() {
			return this.$route.params.website
		},
		id() {
			return this.$route.params.image
		},
		isNew() {
			return this.id === 'new'
		},
	},
	methods: {
		onImport(data) {
			this.image.image = data
		},
		async onSubmit() {
			this.$store.dispatch('app/startLoading')
			try {
				if (this.isNew) {
					await this.$ravello.request()
						.v(2)
						.to('websites')
						.to(this.websiteId)
						.to('images')
						.create({
							filename: this.image.filename,
							namespace: this.image.namespace,
							image: this.image.image,
						})
				} else {
					await this.$ravello.request()
						.v(2)
						.to('websites')
						.to(this.websiteId)
						.to('images')
						.to(this.id)
						.update({
							filename: this.image.filename,
							namespace: this.image.namespace,
							...(this.image.image ? { image: this.image.image } : {}),
						})
				}
				this.$store.dispatch('app/stopLoading')
				this.$notifications.pushAlert('success', `Image successfully ${this.isNew ? 'added' : 'updated'}`)
				this.$router.push({ name: 'website-images' })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
